import { Loading } from 'components/sections';
import { CollectionPage } from 'pages/collectionPage';
import { Error404Page } from 'pages/Error404';
import { MainPage } from 'pages/mainPage';
import { OpenLootboxScreen } from 'pages/openLootboxScreen';
import { WelcomePage } from 'pages/welcomePage';
import { WheelPage } from 'pages/wheelPage';
import { createMemoryRouter } from 'react-router-dom';

export const routes = {
    main: '/main',
    welcome: '/welcome',
    collection: '/collection',
    lootbox: '/lootbox',
    wheel: '/wheel',
    error: '/error'
} as const;

export const router = createMemoryRouter([
    {
        path: routes.main,
        element: <MainPage />
    },
    {
        path: routes.welcome,
        element: <WelcomePage />
    },
    {
        path: routes.lootbox,
        element: <OpenLootboxScreen />
    },
    {
        path: routes.collection,
        element: <CollectionPage />
    },
    {
        path: routes.wheel,
        element: <WheelPage />
    },
    {
        path: routes.error,
        element: <Error404Page />
    },
    {
        path: '*',
        element: <Loading />
    }
]);
